import React from 'react'

import { PersonAvatar } from '@sketch/components'

import {
  TooltipAvatar,
  NotificationAvatarWrapper,
} from '../NotificationListItem.styles'

const NotificationAvatar: React.FCC<{
  avatar: string
  name: string
}> = ({ avatar, name }) => (
  <NotificationAvatarWrapper>
    {avatar ? (
      <TooltipAvatar content={name}>
        <PersonAvatar flavour="image" size="17px" name={name} src={avatar} />
      </TooltipAvatar>
    ) : (
      <PersonAvatar flavour="color" size="17px" name={name} />
    )}
  </NotificationAvatarWrapper>
)

export default NotificationAvatar
